import { Controller } from "stimulus";
import { EventAsyncPricePercentageChanged, EventCurrencyChanged } from "../events";
import { getActiveCurrency } from "../util/currency";

const locale = document.body.getAttribute("data-locale");

// This controller is responsible for executing price percentage changes from websocket updates or user actions.
// There is only one instance of this controller per page for performance reasons.
export default class extends Controller {
  static targets = ["asyncPercent"];

  connect() {
    window.addEventListener(EventAsyncPricePercentageChanged, this._updatePercentageFromWebsocket.bind(this)); // event from WS
    window.addEventListener(EventCurrencyChanged, this._updateAsyncPercentageFromAPI.bind(this)); // event from currency selector
  }

  _getCoinIds() {
    let nodeList = document.querySelectorAll('[data-id]');
    return Array.from(nodeList, node => node.dataset.id);
  }

  _updateAsyncPercentageFromAPI(e) {
    let ids = this._getCoinIds();

    fetch(`/coins/price_percentage_change?ids=${ids}&vs_currency=${getActiveCurrency()}`)
      .then(response => response.json())
      .then(res => {
        this.asyncPercentTargets.forEach(asyncPercentTarget => {

            const percentChange = res[asyncPercentTarget.getAttribute("data-coin-id")][asyncPercentTarget.getAttribute("data-attr")];
            if (percentChange == null) {
              return;
            }

            this._elementDisplayChange(asyncPercentTarget, percentChange);
        });
      });
  }

  _updatePercentageFromWebsocket(e) {
    this.asyncPercentTargets.forEach(asyncPercentTarget => {
      if (asyncPercentTarget.getAttribute("data-24h") !== "true") {
        return;
      }

      const priceChangePercentageJSON = (e.detail && e.detail.priceChangePercentage24H)
      const coinId = e.detail && e.detail.coinId;

      // We only want to live update 24h values.
      if (+asyncPercentTarget.getAttribute("data-coin-id") === +coinId) {
        // Coin match. Proceed with update.
        const currencyCode = (e.detail && e.detail.currencyCode) || getActiveCurrency();
        const percentChange = priceChangePercentageJSON[currencyCode.toLowerCase()];

        if (percentChange == null) {
          return;
        }

        this._elementDisplayChange(asyncPercentTarget, percentChange);
      }
    });
  }

  _elementDisplayChange(asyncPercentTarget, percentChange) {
    let percentChangeDisplay = percentChange.toFixed(1);
    if (asyncPercentTarget.getAttribute("data-formatted") === "true") {
      percentChangeDisplay = percentChange.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2});
    }

    asyncPercentTarget.textContent = `${percentChangeDisplay}%`;

    const upClass = asyncPercentTarget.getAttribute("data-up-class") || "";
    const downClass = asyncPercentTarget.getAttribute("data-down-class") || "";
    if (percentChange > 0) {
      asyncPercentTarget.classList.add(...upClass.split(" "));
      asyncPercentTarget.classList.remove(...downClass.split(" "));

      if (asyncPercentTarget.getAttribute("data-show-solid-arrow") === "true" ||
      asyncPercentTarget.getAttribute("data-is-caret") === "true") {
        asyncPercentTarget.insertAdjacentHTML("afterbegin", '<i class="fas fa-caret-up px-1"></i>')
      }
    } else {
      asyncPercentTarget.classList.add(...downClass.split(" "));
      asyncPercentTarget.classList.remove(...upClass.split(" "));

      if (asyncPercentTarget.getAttribute("data-show-solid-arrow") === "true" ||
      asyncPercentTarget.getAttribute("data-is-caret") === "true") {
        asyncPercentTarget.textContent = `${Math.abs(percentChange.toFixed(1))}%`;
        asyncPercentTarget.insertAdjacentHTML("afterbegin", '<i class="fas fa-caret-down px-1"></i>')
      }
    }

    const percentIconTarget = asyncPercentTarget.getElementsByTagName("i")[0];
    if (percentIconTarget) {
      const iconUpClass = percentIconTarget.getAttribute("data-icon-up-class");
      const iconDownClass = percentIconTarget.getAttribute("data-icon-down-class");

      if (percentChange > 0) {
        percentIconTarget.classList.add(iconUpClass);
        percentIconTarget.classList.remove(iconDownClass);
      } else {
        percentIconTarget.classList.add(iconDownClass);
        percentIconTarget.classList.remove(iconUpClass);
      }
    }
  }
}
